import { ARCHITECT_CONFIG } from './architect-config';
const ɵ0 = ARCHITECT_CONFIG;
export class AppModule {
}
export { ɵ0 };
